import React from 'react'

import Icon from '../../../../components/ui/Icon/Icon'
import styles from './IconWarning.module.scss'

const IconWarning = () => {
  return (
    <div className={styles.icon}>
      <Icon name='warning' />
    </div>
  )
}

export default IconWarning
